import React from 'react';

// Shown wherever projected taxes are displayed. The UK rental-tax figure uses
// a deliberately conservative interim basis (tends to overstate UK tax) while
// awaiting professional confirmation - see
// docs/features/planned/tax-engine-validation.md.
const TaxAssumptionNote: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`bg-amber-50 border border-amber-300 text-amber-900 rounded-lg p-4 text-sm ${className || ''}`}>
    <div className="font-semibold mb-1">⚠️ UK tax — conservative interim assumption (pending professional confirmation)</div>
    <p className="mb-2">
      UK rental tax is calculated on a deliberately prudent basis that tends to <strong>overstate</strong> UK tax,
      pending sign-off from a France/UK tax adviser. Specifically:
    </p>
    <ul className="list-disc ml-5 space-y-0.5">
      <li>French LMNP depreciation is <strong>not</strong> relieved against UK tax (the UK is taxed on the pre-depreciation profit).</li>
      <li>Mortgage interest is <strong>restricted</strong> to a 20% UK basic-rate tax reducer (UK s.24), not deducted in full.</li>
      <li>French social charges (the 7.5% solidarity levy) are <strong>not</strong> credited against UK tax.</li>
    </ul>
    <p className="mt-2 text-amber-800">
      French tax, the standalone France-UK tax calculator, and capital gains are unaffected. Treat these figures as a
      cautious upper bound on UK tax, not filing advice.
    </p>
  </div>
);

export default TaxAssumptionNote;
